<template>
  <div class="rdmanagement-pc">
    <!-- <time-line></time-line> -->
    <!-- <radar></radar> -->
    <project @updateActivekey="updateActivekey"></project>
    <div class="df both-side" v-if="store.state.project">
      <project-announcement customText="项目公告" :feedbackType="projectAnnouncementText" />
      <project-announcement customText="项目日志" :feedbackType="projectAnnouncementLog" />
    </div>
  </div>
</template>

<script>
import { computed, defineComponent, ref } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { setAuthority } from '@/views/rdmanagement/serve/authority';
import dataBase from "@/views/rdmanagement/components/database/index.vue";
import project from "@/views/rdmanagement/components/project/index.vue";
import projectLog from "@/views/rdmanagement/components/projectLog/index.vue";
import projectAnnouncement from "@/views/rdmanagement/components/projectAnnouncement/index.vue";
import timeLine from "./timeline.vue";
import radar from "./radar.vue";
// import feedbackVue from "@/views/productDaily/components/feedback/index.vue";

export default defineComponent({
  name: "projectmanagement",
  components: { dataBase, project, projectLog, projectAnnouncement, timeLine, radar },
  setup() {
    const store = useStore();

    const route = useRoute();

    setAuthority(route.meta);

    const projectAnnouncementText = computed(() => {
      return `${store.state.project}项目公告`;
    });
    const projectAnnouncementLog = computed(() => {
      return `${store.state.project}项目日志`;
    });
    return {
      store,
      projectAnnouncementText,
      projectAnnouncementLog,
    };
  },
});
</script>
<style lang="less" scoped>
.rdmanagement-pc {
  background: #fff;
  width: 100%;
  height: calc(100vh - 110px);
  box-shadow: 0 0 10px 0 #ccc;
  border-radius: 20px;
  padding: 15px;
}
</style>
